<template>
  <div>
    <filter-bar></filter-bar>
    <vuetable ref="vuetable" :api-url="apiURL" :fields="fields" pagination-path="meta" :css="css.table"
      :sort-order="sortOrder" :multi-sort="true" detail-row-component="my-detail-row" :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData"></vuetable>
    <div class="vuetable-pagination">
      <vuetable-pagination-info ref="paginationInfo" info-class="pagination-info"></vuetable-pagination-info>
      <vuetable-pagination ref="pagination" :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    </div>
  </div>
</template>

<script>
import accounting from 'accounting'
import moment from 'moment'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import Vue from 'vue'
import VueEvents from 'vue-events'
import VuejsDialog from "vuejs-dialog"
import CodesActions from './CodesActions'
import FilterBar from './FilterBar'
Vue.use(VueEvents)
Vue.use(VuejsDialog)
Vue.component('code-actions', CodesActions)
Vue.component('filter-bar', FilterBar)

function getApiURLbyID() {
  var urlpath = window.location.pathname
  var segments = urlpath.split("/");
  // Alleen output als we een ID hebben

  if (segments[2] === undefined) {
    return "/api/codes/"
  } else {
    return "/api/codes/" + segments[2];
  }
}


var dataURL = getApiURLbyID();

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  data() {
    return {
      apiURL: dataURL,
      noDataTemplate: 'Er zijn geen codes voor deze account gevonden',
      fields: [
        {
          name: 'bedrijfsnaam',
          sortField: 'bedrijfsnaam'
        },
        {
          name: 'email',
          sortField: 'email'
        },
        {
          name: 'naam',
          sortField: 'naam'
        },
        {
          name: 'uitgenodigd',
          sortField: 'uitgenodigd',
          label: 'uitgenodigd'
        },
        {
          name: 'aangemaakt',
          sortField: 'aangemaakt',
          label: 'uitgenodigd'
        },
        {
          name: 'code',
          sortField: 'code'
        },
        {
          name: 'versie',
          sortField: 'versie'
        },
        {
          name: '__component:code-actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ],

      css: {
        table: {
          tableClass: 'table table-bordered table-striped table-hover',
          ascendingIcon: 'fas fa-sort-up',
          descendingIcon: 'fas fa-sort-down'
        },
        pagination: {
          wrapperClass: 'pagination',
          activeClass: 'active',
          disabledClass: 'disabled',
          pageClass: 'page',
          linkClass: 'link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
        icons: {
          first: 'fas fa-backward',
          prev: 'fas fa-caret-left',
          next: 'fas fa-caret-right',
          last: 'fas fa-forward',
        },
      },
      sortOrder: [
        { field: 'name', sortField: 'name', direction: 'asc' }
      ],
      moreParams: {},
    }
  },
  methods: {
    allcap(value) {
      return value.toUpperCase()
    },

    statusLabel(value) {

      console.log(value);

      if (value === '0') {
        return '<span class="btn btn-success"><i class="fas fa-check-square"></i> &nbsp; gebruikt</span>'
      } else {
        return '<span class="btn btn-danger"><i class="fas fa-square"></i> &nbsp; ongebruikt</span>'
      }
    },

    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page)
    },
  },
  events: {
    'filter-set'(filterText) {
      this.moreParams = {
        filter: filterText
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    'filter-reset'() {
      this.moreParams = {}
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    }
  }
}
</script>
<style>
.pagination {
  margin: 0;
  float: right;
}

.pagination a.page {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 5px 10px;
  margin-right: 2px;
}

.pagination a.page.active {
  color: white;
  background-color: #337ab7;
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 5px 10px;
  margin-right: 2px;
}

.pagination a.btn-nav {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 5px 7px;
  margin-right: 2px;
}

.pagination a.btn-nav.disabled {
  color: lightgray;
  border: 1px solid lightgray;
  border-radius: 3px;
  padding: 5px 7px;
  margin-right: 2px;
  cursor: not-allowed;
}

.pagination-info {
  float: left;
}
</style>